// StudioWorkspace.js - what each page shows (logistics-workflow's SMBLogistics.js, for this app). The Studio and Item library
// tabs are the Game Builder's own screens; their walkthroughs start the first time those screens open.
import React, { useEffect, useMemo } from "react";
import Dashboard from "../components/Dashboard";
import Results from "../components/dashboard/Results";
import AuditTrailList from "../components/audit/AuditTrailList";
import SettingsPage from "../components/settings/SettingsPage";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import GameBuilder from "../game-builder/components/GameBuilder";
import InventoryCatalog from "../game-builder/components/InventoryCatalog";
import { useTourWhenVisible } from "../reacttour/StudioTourContext";
import TourButton from "../reacttour/TourButton";
import { useProfile, isAdmin, isOwner } from "../context/ProfileContext";

// ?plan=<id> opens that plan, ?new=1 a new one; read once, then taken off the address so a reload doesn't repeat it.
function StudioTab() {
  const { profile } = useProfile();
  const location = useLocation();
  const [params, setParams] = useSearchParams();
  const wanted = params.get("plan") || params.get("new");
  const request = useMemo(() => (wanted ? { plan: params.get("plan"), create: params.get("new") === "1", at: location.key } : null),
    [wanted, location.key]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (wanted) setParams({}, { replace: true }); }, [wanted, setParams]);
  useTourWhenVisible('[data-tour="np-sources"]', "new-plan");
  useTourWhenVisible('[data-tour="pe-approve"]', "path-review",
    () => ({ plain: !!document.querySelector('[data-tour="pe-plain"]') }));
  const welcomeContext = () => ({
    hasPlans: !!document.querySelector('[data-tour="gb-plans"]'), isDemo: !!profile?.org?.is_demo, isOwner: isOwner(profile),
    isAdmin: isAdmin(profile),
  });
  return (
    <GameBuilder request={request} canBrowseItems={isAdmin(profile)}
      headerExtra={<TourButton tour="welcome" context={welcomeContext} title="Show me around" />} />
  );
}

// The item library - the platform admin's only (anyone else opening /app/items gets the dashboard)
function ItemsTab() {
  const { profile } = useProfile();
  const navigate = useNavigate();
  if (!isAdmin(profile)) return <Dashboard />;
  return <div className="gb-page"><InventoryCatalog onClose={() => navigate("/app/studio")} /></div>;
}

export default function StudioWorkspace({ activeTab, token, logout }) {
  switch (activeTab) {
    case "studio":
      return <StudioTab />;
    case "items":
      return <ItemsTab />;
    case "results":
      return <Results />;
    case "audit":
      return <AuditTrailList />;
    case "settings":
      return <SettingsPage token={token} logout={logout} />;
    default:
      return <Dashboard />;
  }
}
